import { Model } from '@shared-features/models/model';
import { Expose } from 'class-transformer';

export class ShipmentsCountStatus extends Model {
  @Expose() hiddenShipmentCount: number;
  @Expose() duplicatedShipmentCount: number;
}
